import React from "react";
import Container from "./Container";
import BackView, {View, HeadCard, BackIcon} from "../styles/HeadView";
import {Content} from "../styles/GlobalStyles";
import {useHistory} from "react-router-dom";
import {ContentContainer} from "../styles/Products";

export default function BasicView({children, imageBack, isSecondary, paddingHead, borderNone}) {
   let history = useHistory();
   return (
      <Container>
         <BackView style={{backgroundImage: `url(${imageBack})`}}>
            {isSecondary && (
               <Content>
                  <BackIcon onClick={() => history.goBack()}>
                     <img src={require("../assets/icons/arrowLeft.png")} alt="back" />
                     REGRESAR
                  </BackIcon>
               </Content>
            )}
         </BackView>
         <Content color="orange" className="orange">
            <HeadCard borderNone={borderNone}>
               <Content className="content" style={{paddingTop: "2em"}}>
                  {children[0]}
               </Content>
            </HeadCard>
         </Content>
         <View>{children[1]}</View>
      </Container>
   );
}

BasicView.defaultProps = {
   isSecondary: false,
};
